import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Import components
import TileView from './TileView';

class TileController extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sizeClass: '',
      src: {},
    };
  }

  componentWillMount() {
    this.setSizeAndSource(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setSizeAndSource(nextProps);
  }

  setSizeAndSource(props) {
    switch (props.size) {
      case 1:
        this.setState({
          sizeClass: 'm-tile--medium',
          src: {
            sm: props.image['1020'],
            md: props.image['1020'],
            lg: props.image['1280'],
            xl: props.image['1280'],
            xxl: props.image['1280'],
            xxxl: props.image['2560'],
            default: props.image.default,
          },
        });
        break;
      case 2:
        this.setState({
          sizeClass: 'm-tile--large',
          src: {
            sm: props.image['1020'],
            md: props.image['1020'],
            lg: props.image['1280'],
            xl: props.image['1280'],
            xxl: props.image['1280'],
            xxxl: props.image['2560'],
            default: props.image.default,
          },
        });
        break;
      case 4:
        // used for tiles in the teaser view
        this.setState({
          sizeClass: 'm-tile--medium',
          src: {
            sm: props.image['1020'],
            md: props.image['750'],
            lg: props.image['1020'],
            xl: props.image['750'],
            xxl: props.image['1020'],
            xxxl: props.image['2560'],
            default: props.image.default,
          },
        });
        break;
      default:
        this.setState({
          sizeClass: 'm-tile--any',
          src: {
            sm: props.image['1020'],
            md: props.image['1020'],
            lg: props.image['620'],
            xl: props.image['620'],
            xxl: props.image['620'],
            xxxl: props.image['2560'],
            default: props.image.default,
          },
        });
    }
  }

  render() {
    return (
      <TileView {...this.props} src={this.state.src} sizeClass={this.state.sizeClass} />
    );
  }
}

TileController.propTypes = {
  size: PropTypes.number,
  image: PropTypes.shape(),
};

TileController.defaultProps = {
  size: 1,
  image: {},
};

function mapStateToProps(state) {
  return {
    lang: state.globalsState.lang,
  };
}

export default connect(mapStateToProps)(TileController);




// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/Tile/TileController.jsx